<template>
<div class=" animate_class">
<div class="grid custom_input_wrap mr-0 ml-0">

<template v-if="nonconformity_status=='loading'">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="is_expired">
  <h3 class="text-red-500 font-bold">{{$store.state.languages.lang_phrases.uygunsuzluk_kapama_aktif_degil}}</h3>  
</template>


<template v-if="nonconformity_status=='accepted'">
<div class="col-12">
<p class="text-green-500 font-bold">{{$store.state.languages.lang_phrases.son_dogrulama_kaydiniz_kabul_edildi_bu_soru_ile_ilgili_uygunsuzluk_kapatildi}}</p>
</div>
</template>

<template v-if="nonconformity_status=='pending'">
<div class="col-12">
<p class="text-red-700 font-bold my-0">{{$store.state.languages.lang_phrases.son_dogrulama_kaydiniz_kontrol_ediliyor}}</p>
<hr>
</div>
<div class="col-12">
<Button  icon="pi pi-trash" :label="$store.state.languages.lang_phrases.son_basvurunuzu_geri_cekin" @click="retrieveClosure" class=" p-button-danger p-button-outlined  p-button-sm" :loading="deleting"/>
</div>
<div class="col-12">
<p class="font-bold text-primary">{{$store.state.languages.lang_phrases.son_dogrulama_kaydiniz}}</p>
<p class="">{{nonconformity.lastclosurerequest.text}}</p>
</div>
</template>


<template v-if="nonconformity_status=='rejected'">
<div class="col-12">
<p class="text-purple-500 font-bold">{{$store.state.languages.lang_phrases.son_dogrulama_kaydiniz_kontrol_edildi_ve_yeterli_bulunmadi}}</p>
</div>
</template>

<template v-if="nonconformity.evidences.length">
<p class="font-bold text-primary">{{$store.state.languages.lang_phrases.yuklenen_kanit_dosyalari}}</p>


<div class="col-12" v-for="item in nonconformity.evidences">
<div class="grid">
<div class="col-10" >
<a class="p-text-secondary" :href="apiurl+item.filepath" target="_blank">{{item.filename}}</a>
</div>


<div class="col-2" v-if="nonconformity_status=='pending' || nonconformity_status=='rejected' || nonconformity_status=='awaiting'">
<Button  icon="pi pi-trash"  @click="deleteEvidence(item.id)" class=" p-button-danger p-button-outlined  p-button-sm" :loading="deleting"/> 
</div>


</div>
</div>


</template>

<template v-if="!is_expired">
<template v-if="nonconformity_status=='awaiting' || nonconformity_status=='rejected'">
<div class="col-12">
<h4 class="text-primary mt-1">{{$store.state.languages.lang_phrases.lutfen_uygunsuzluk_konusu_olan_soru_ile_ilgili_duzeltme_calismanizi_bildirin}}</h4>
</div>
</template>
</template>


<!-- input area-->
<template v-if="!is_expired">  
  
<h4 class="text-red-500 font-normal m-0 ml-2">
  <span class="font-normal">{{$store.state.languages.lang_phrases.son_gun}}: </span>
  <span class="font-bold">{{ $filters.momentFormat( closure_expire_time," Do-MM-YYYY")}}</span>
</h4>
  


<template v-if="nonconformity_status=='awaiting' || nonconformity_status=='rejected'">
<div class="col-12">
<Textarea v-model="text" rows="3" autoResize  class="w-full p-inputtext-sm mb-0"  id="nonconformity_text" :class="{ has_error: has_error }"/>
</div>

<div class="col-12 animate_class" v-show="showuploader">
<FileUpload name="cover_image[]" ref="cover_image" @select="onFilesAdded"  @remove="onFilesAdded"   v-model="files" :multiple="true" :showUploadButton="false" :showCancelButton="false" :chooseLabel="$store.state.languages.lang_phrases.dosya_secin"    :maxFileSize="10000000000" class="" :fileLimit="5">
  <template #empty>
      <div class="uploader_empty">
      <span class="material-icons-outlined md-48 mr-2">backup
    </span>
      <p>{{$store.state.languages.lang_phrases.dosyalari_buraya_surukleyip_birakin}}</p>
    </div>
  </template>
</FileUpload>


</div>
<div class="col-12">
<div class="flex justify-content-end flex-wrap mt-3">
 <Button :label="$store.state.languages.lang_phrases.iptal" class=" p-button-danger p-button-outlined  p-button-sm" @click="hideUploader"  v-if="showuploader"></Button>
 <Button :label="$store.state.languages.lang_phrases.kanit_yukle" class=" p-button-info p-button-outlined  p-button-sm" @click="showUploader" v-if="!showuploader"></Button>

  <Button :label="$store.state.languages.lang_phrases.kaydet" class=" p-button-primary p-button-outlined  p-button-sm ml-2" :loading="$store.state.ui.submitting" @click="submit"></Button>
</div>
</div>
</template>
</template>


<!-- input area-->




</div>


<div class="grid custom_input_wrap mr-0 ml-0 mt-4" v-if="closurerequests">
<div class="col-12">
<p class="text-primary font-bold">{{$store.state.languages.lang_phrases.onceki_kapatma_talepleri}}</p>

<div class="grid" v-for="item in nonconformity.closurerequests">
<div class="col-12 md:col-8">
<p class="text-purple-500 mt-0 mb-0">{{item.submittedby.name}}</p>
</div>
<div class="col-12 md:col-4">
<div class="flex justify-content-end flex-wrap ">
<small class="p-text-secondary font-bold" >{{ $filters.momentFormat( item.created_at," DD-MM-YYYY")}}</small>
</div>
</div>

<template v-if="item.status=='rejected'">
<div class="col-12">
<small class="text-red-700 mt-0 mb-0" v-if="$store.state.auth.user.preflang_id==3"> <b>{{item.resolvedby.name}}</b> {{$store.state.languages.lang_phrases.tarafindan}} <b> {{ $filters.momentFormat( item.updated_at," DD-MM-YYYY")}}</b> {{$store.state.languages.lang_phrases.tarihinde_reddedildi}}</small>

<small class="text-red-700 mt-0 mb-0" v-else>  {{$store.state.languages.lang_phrases.tarihinde_reddedildi}} <b> {{ $filters.momentFormat( item.updated_at," DD-MM-YYYY")}}</b> {{$store.state.languages.lang_phrases.tarafindan}}  <b>{{item.resolvedby.name}}</b> </small>
</div>

<div class="col-12" v-if="item.rejectiontext">
<small class="text-pink-500 mt-0 mb-0"> <b>{{$store.state.languages.lang_phrases.red_sebebi}}: </b> {{item.rejectiontext}}</small>
</div>
</template>

<template v-if="item.status=='approved'" >
<div class="col-12">
<small class="text-green-500 mt-0 mb-0" v-if="$store.state.auth.user.preflang_id==3"> <b>{{item.resolvedby.name}}</b> {{$store.state.languages.lang_phrases.tarafindan}} <b> {{ $filters.momentFormat( item.updated_at," DD-MM-YYYY")}}</b> {{$store.state.languages.lang_phrases.tarihinde_kabul_edildi}}</small>
<small class="text-green-500 mt-0 mb-0" v-else>  {{$store.state.languages.lang_phrases.tarihinde_kabul_edildi}} <b> {{ $filters.momentFormat( item.updated_at," DD-MM-YYYY")}}</b> {{$store.state.languages.lang_phrases.tarafindan}}  <b>{{item.resolvedby.name}}</b> </small>
<hr>
</div>
</template>

<div class="col-12">
<p class="mt-0">{{item.text}}</p>
<hr>
</div>

</div>

</div>

</div>

</div>	
</template>

<script>
import moment from "moment"
export default {

  name: 'NonconformityPanel',
  props:["nonconformity"],
  data () {
    return {
      text:null,
      files:[],
      has_error:false,
      showuploader:false,
      deleting:false,
    }
  },
  computed:{
    closurerequests()
    {
      if(this.nonconformity.closurerequests.length)
      {
        return true
      }
      return false
    },
    nonconformity_status()
    {
      if(this.nonconformity )
      {
        if(this.nonconformity.status=="open")
        {
            if(this.nonconformity.lastclosurerequest)
            {
              if(this.nonconformity.lastclosurerequest.status=="pending")
              {
                return "pending"
              }
              if(this.nonconformity.lastclosurerequest.status=="rejected")
              {
                return "rejected"
              }
            }
            else
            {
              return "awaiting"
            }
        }
        else
        {
          return "accepted"
        }
        
      }

      return "loading"
    },
    apiurl()
    {
      let api =  process.env.VUE_APP_API_HOOK
      api = api.replace("/api/","/")
      //return api
      return "https://storage.googleapis.com/verifycloud/"
    },
    is_expired()
    {
      if(this.nonconformity && this.nonconformity.flowsupplier.projectperiod.enddate)
      {
        let now = moment()
        let end = moment(this.nonconformity.flowsupplier.projectperiod.enddate)  
        if(end.isBefore(now))
        {
          let settings
          if(this.nonconformity.flowsupplier.flow.type=="verification")
          {
            settings = this.nonconformity.flowsupplier.flow.verificationsettings
          }
          if(this.nonconformity.flowsupplier.flow.type=="audit")
          {
            settings = this.nonconformity.flowsupplier.flow.auditsettings
          }
          
          if(settings.allow_closure_after_expire && this.nonconformity.nonconformitytype.closure_expire_time)
          {
            end = end.add(this.nonconformity.nonconformitytype.closure_expire_time, 'd')                       
            if(end.isBefore(now))
            {
              return true
            }
            return false
          }
          return true
        }
        return false
      }
      return false
    },
    closure_expire_time()
    {
      let now = moment()
      let settings
      let end = moment(this.nonconformity.flowsupplier.projectperiod.enddate)
      if(this.nonconformity.flowsupplier.flow.type=="verification")
      {
        settings = this.nonconformity.flowsupplier.flow.verificationsettings
      }
      if(this.nonconformity.flowsupplier.flow.type=="audit")
      {
        settings = this.nonconformity.flowsupplier.flow.auditsettings
      }
      if(settings.allow_closure_after_expire && this.nonconformity.nonconformitytype.closure_expire_time)
      {
        end = end.add(this.nonconformity.nonconformitytype.closure_expire_time, 'd')
        return end
        //let duration = moment.duration(end.diff(now));
        //let days = duration.asDays();
        //return Math.round(days)
      }
      else
      {    
        return end    
        //let duration = moment.duration(now.diff(end));
        //let days = duration.asDays();
        //return Math.round(days)
      }
    }
  },
  mounted()
  {
    console.log(this.nonconformity)
  },
  methods:{
    retrieveClosure()
    {
      this.deleting = true
      let formdata = new FormData()
      this.generalSubmission(formdata,"retrieve_closure/"+this.nonconformity.id,this.afterSubmit)
    },
    deleteEvidence(id)
    {
      this.deleting = true
      let formdata = new FormData()
      this.generalSubmission(formdata,"delete_nonconformity_evidence/"+id,this.afterSubmit)
    },
    onFilesAdded(event)
    {
      this.files = []
      for(let file of event.files)
      {
        this.files.push(file)
      }
    },
    showUploader()
    {
      this.showuploader = true
    },
    hideUploader()
    {
      this.files = []
      //this.$refs.cover_image.value = ''
      this.showuploader = false
    },
    submit()
    {
      
      if(this.text=="" || !this.text)
      {
        this.has_error = true
        this.submitting = false
        this.showMessage("error",this.$store.state.languages.lang_phrases.lutfen_bu_alani_doldurun)
        //this.$refs.textarea.focus()
        
        document.getElementById("nonconformity_text").focus();
        setTimeout(()=>{
          this.has_error = false
        },3000)
        return  false
      }
      let formdata = new FormData()
      formdata.append("text",this.text)
      formdata.append("flowsupplier_id",this.$route.params.id)
      for( var i = 0; i < this.files.length; i++ ){
        let file =  this.files[i];
        formdata.append('files[' + i + ']', file);
      }
      
      //return false
      this.generalSubmission(formdata,"submit_nonconformity_closure_request/"+this.nonconformity.id,this.afterSubmit)
    },
    afterSubmit(response)
    {
      this.deleting = false
      this.text = null
      this.files = []
      this.hideUploader()
      this.$emit("nonconformityDataUpdated",response.data)
      
    },
  }
}
</script>

<style lang="css" scoped>
</style>